import type { EmailContext } from "./types";

/**
 * Copy for the "Create new case from email" affordance shown in
 * AddConnectionSinglePage when the Case tab is active. Only Cases
 * support inline creation today.
 */
export function createNewCopy(email: EmailContext): { label: string; hint: string } {
  return {
    label: "Create new case from email",
    hint: `Pre-fills name "${email.subject.replace(/^Re:\s*/i, "").trim()}"`,
  };
}
